import React, { Component } from 'react';

class TtsDeploy extends Component {

    routeToReferenceDoc = () => {
        window.open("https://github.com/DheeYantra/dhee-online-transcription-api-js", "_blank")
    }

    render() {
        return (
            <div>
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <div className="wrapper" style={{ height: "auto" }}>
                    <div className="row">
                        <div className="col-12">
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '10px', marginLeft: '20px'
                            }}>Deploy</h6>

                            <div className="card-body p-0 mb-25" style={{ marginLeft: "20px" }}>
                                <div className="tab-content col-12 p-0">
                                    <div className="tab-pane active show" id="tab_1">
                                        <div className="card card-primary mt-3">
                                            <div className="card-body raise-form">
                                                <div className="col-sm-12">
                                                    <div className="col-sm-7">
                                                        <div style={{ width: 'auto' }}>
                                                            <div style={{
                                                                marginTop: '10px', marginLeft: '20px', color: '#282a65',
                                                            }}>For TTS usage you will be charged 10 paise per API call
                                                            </div>
                                                            <div style={{
                                                                marginTop: '10px', marginLeft: '20px', color: '#282a65',
                                                            }}>Please deploy from <a href={window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget"}>Unified Project Launchpad</a>
                                                            </div>
                                                            <div style={{ marginTop: '20px', marginLeft: '20px' }}>
                                                                <h4>Note:</h4>
                                                                <div style={{ lineHeight: '2', marginTop: '-7px', color: '#282a65' }}>
                                                                    To integrate Text to speech to your application please follow below information.<br /><br />
                                                                    <h3>Dhee.AI Text to speech REST API</h3>
                                                                    The Text to speech API of Dhee.AI helps you to convert text to speech.
                                                                    The API is to be used via REST calls, as per the specifications below:
                                                                    <br /> <br />
                                                                    <h4>Request Format</h4>
                                                                    <table width="100%" border="1">
                                                                        <tr>
                                                                            <td style={{paddingLeft: '5px'}}>URL</td>
                                                                            <td style={{paddingLeft: '5px'}}>https://runtime.dhee.ai/tts/<span>&#10100;</span>projectId<span>&#10101;</span>/text-to-speech</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{paddingLeft: '5px'}}>METHOD</td>
                                                                            <td style={{paddingLeft: '5px'}}>POST</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{paddingLeft: '5px'}}>Authentication</td>
                                                                            <td style={{paddingLeft: '5px'}}>Basic, with apiKey & secret</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{paddingLeft: '5px'}}>Parameters</td>
                                                                            <td style={{paddingLeft: '5px'}}>text, language<br />
                                                                                text : The text to be converted.<br />
                                                                                language : language in which text should be converted.
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                    <br />
                                                                    <h4>Request Headers</h4>
                                                                    <table width="100%" border="1">
                                                                        <tr>
                                                                            <td style={{paddingLeft: '5px'}}>Content-Type
                                                                            </td>
                                                                            <td style={{paddingLeft: '5px'}}>application/x-www-form-urlencoded
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{paddingLeft: '5px'}}>authorization</td>
                                                                            <td style={{paddingLeft: '5px'}}>POST</td>
                                                                        </tr>
                                                                    </table>
                                                                    <br /><h4>Response Format</h4>
                                                                    The output response body will be in byte array which is used in audio element
                                                                    <br />
                                                                    <br />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
export default TtsDeploy;


// WEBPACK FOOTER //
// ./src/ttsUi/TtsDeploy.js